
































































































































































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwPanelGroup, SwPanel } from '@libs-uuif/shared/sw-panel';
import AnotherProduct from './another-product.vue';
import { ProductModalObjectType, ProductModalObject, MSSPPrefilterResponseType, TenantPrefilterList, MsspPrefilterList, AnotherProductObjectModalType, FwProductObjectType } from '../types';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import  { MswApiService } from '@/shared/msw-api-service';
import { currentUserKey } from '@/shared/msw-constants';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { SwBlockingProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-blocking-progress';
import idb, { TENANTS_STORE_NAME } from '@/services/indexedDb.service';
import { envCongif } from '@/shared/env.config';

interface PanelData {
  id: number;
  title: string;
  data: ProductModalObjectType;
}

const cssPrefix = 'add-product-modal';
@Component({
  components: {
    ...UUIFComponents,
    SwTextarea,
    SwPanelGroup,
    SwPanel,
    SwBlockingProgress,
    AnotherProduct,
  }, directives: {
    tooltip,
  },
})
export default class AddProductModal extends SwExtendedVue {

  @Prop({ type: String })
  modalMode: string;
  @Prop()
  msspPrefilterList: any;

  @Prop()
  showRename: boolean;

  @Prop()
  msspFiltered: boolean;

  @Prop()
  tenantFiltered: boolean;

  @Prop()
  selectedMSSPID: any;
  @Prop()
  selectedTenantID: any;

  @Prop()
  todayDate: any;

  @Prop({ type: String })
  productRegion: string;

  @Prop()
  addressWarning: string;

  cssPrefix = cssPrefix;
  mSSPname: string = '';
  tenantName: string = '';
  tenantId = '';
  expandedPanels: string[] = [];
  msspOptions: SelectOption[] = [];
  tenantOptions: SelectOption[] = [];
  editAlowed = false;
  tempDatas: PanelData[] = [{
    id : 1,
    title : 'Product 1',
    data: {
      productName: 'Product 1',
      productId: '',
      serviceName: '',
      serviceId:  '',
      unitSelected: 'noUpperLimit',
      expiryType: 'Never',
      regionSelected: '',
      platform: '',
      showHA: '',
    },
  }];
  newProductModalObject: ProductModalObject = {
    MSSPname: '',
    MsspId: '',
    tenantName: '',
    tenantId: '',
    productDetails: [],
    accessScopeMessage: '',
    authCode: '',
    serialNumber: '',
    friendlyName: '',
    performFurtherValidation: false,
    isdefaultgroupAssignedtoTenant: false,
  };
  enableAddAnotherProduct: boolean = false;
  msspPrefilterResponseFromApi: MSSPPrefilterResponseType;
  showErrorMsg = false;
  showErrorMsgAnotherProductModal = false;
  enableProductListApiCall: boolean = false;
  msspCheck: boolean = false;
  tenantCheck: boolean = false;
  tenantWarning: boolean = false;
  enableProvision: boolean = false;
  bodyBlockingVisible: boolean = false;
  unitSelected:string = '';
  childUnitSelected: string = '';
  tzRequest: FwProductObjectType = {
    productGroupId: '',
    Mode: 'Provision',
    ProductID: '',
    serialNumber: '',
    serviceId: '',
    nodeCount: '',
    subDomain: '',
    expirationDate: '',
    regionName: '',
    regionID: '',
    friendlyName: '',
    validationMessage: '',
    isZT: 'NO',
    isHA: 'NO',
    Services: [{
      serviceId: '',
      nodeCount: '1',
      expirationDate: '',
    }, {
      serviceId: '',
      nodeCount: '1',
      expirationDate: '',
    }],
  };
  isTzSelected: boolean = false;
  changed: boolean = false;
  isDcApplies: boolean = false;
  showExpiry: boolean = false;
  showChildExpiry: boolean = false;
  sslVpnObject: any = {};
  affiliateTenantText: string = '';
  cseAutoRedirect: string;

  handlePanelChange(expandedPanels: string[]) {
    this.expandedPanels = expandedPanels.slice(0);
  }
  callTmgmt() {
    this.$emit('callMgmt');
  }
  onCancel() {
    localStorage.setItem('tenants', '');
    this.$emit('onclosePrductModal');
  }

  get getValidationFlag() {
    let flag = false;
    const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    const platFormFlag = productModalDetails.showPlatFormOptions ? productModalDetails.platformName !== '' : true;
    const unitSelectedFlag = productModalDetails.unitSelected !== 'noUpperLimit' && productModalDetails.showUnits ? productModalDetails.upperLimit !== ''
    && Number(productModalDetails.upperLimit) >= 1 && Number(productModalDetails.upperLimit) <= 99999 : true;
    const expirySelectedFlag = productModalDetails.expiryType !== 'Never' ? productModalDetails.expiryType !== '' : true;
    const subDomainFlag = productModalDetails.showSubDomainName ? productModalDetails.subDomain !== '' : true;
    const applicatioFlag = productModalDetails.showApplicationOption ? productModalDetails.applicationName !== '' : true;
    const regionFlag = this.modalMode === 'add' && productModalDetails.showRegion ? productModalDetails.regionName !== '' : true;
    flag = (this.newProductModalObject.MSSPname !== '') && (this.newProductModalObject.tenantName !== '') && (productModalDetails.productId !== '') && (productModalDetails.serviceName !== '') && (productModalDetails.friendlyName   !== '')
        && regionFlag && platFormFlag && unitSelectedFlag && expirySelectedFlag && subDomainFlag && applicatioFlag;
    return flag;
  }
  get tzValidations() {
    let flag = true;
    // console.warn('rez', this.tzRequest.serialNumber === '', this.tzRequest.serialNumber === 'register', this.tzRequest.Services[0].serviceId === '', this.tzRequest);
    // console.warn('rez1', this.tzRequest.Services[1].serviceId === '', this.tzRequest.Services[0].expirationDate === '' && this.showExpiry, this.tzRequest.Services[1].expirationDate === '', (this.tzRequest.regionName === '' && this.tzRequest.regionID === ''));
    const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    if (productModalDetails.showOrganizationId) {
      if (this.tzRequest.Services[0].serviceId === '' || this.tzRequest.Services[1].serviceId === '' ||
      (this.tzRequest.Services[0].expirationDate === '' && this.showExpiry) || (this.tzRequest.Services[1].expirationDate === '' && this.showChildExpiry) ||
      (this.tzRequest.regionName === '' && (this.tzRequest.regionID === '' || this.tzRequest.regionID === '-1')) || this.tzRequest.subDomain === '' ||
      (this.unitSelected && (this.tzRequest.Services[0].nodeCount === '' || (Number(this.tzRequest.Services[0].nodeCount) < 1 || Number(this.tzRequest.Services[0].nodeCount) > 99999))) ||
      (this.childUnitSelected && (this.tzRequest.Services[1].nodeCount === '' || (Number(this.tzRequest.Services[1].nodeCount) < 1 || Number(this.tzRequest.Services[1].nodeCount) > 99999)))) {
        flag = false;
      }
    } else if (productModalDetails.productId === '-7' || productModalDetails.productId === '-8') {
      if ((this.tzRequest.serialNumber === '' || this.tzRequest.serialNumber === 'register') ||
      (this.tzRequest.Services[0].serviceId === '' ||
        (this.tzRequest.Services[0].expirationDate === '' && this.showExpiry) ||
        (this.tzRequest.regionName === '' && (this.tzRequest.regionID === '' || this.tzRequest.regionID === '-1')))) {
        flag = false;
      }
    } else if ((productModalDetails.productId === '-1' && (this.tzRequest.serialNumber === '' || this.tzRequest.serialNumber === 'register'))  ||
     ((this.tzRequest.ProductID.toString() === '27102' || this.tzRequest.ProductID.toString() === '27104' || this.tzRequest.ProductID.toString() === '27121' || this.tzRequest.ProductID.toString() === '28121') &&
      this.tzRequest.friendlyName === '') ||
     this.tzRequest.Services[0].serviceId === '' || this.tzRequest.Services[1].serviceId === '' ||
     (this.tzRequest.Services[0].expirationDate === '' && this.showExpiry) || (this.tzRequest.Services[1].expirationDate === '' && this.showChildExpiry) ||
     (this.tzRequest.regionName === '' && this.tzRequest.regionID === '' && this.isDcApplies)) {
      flag = false;
    }
    const sslVpnFlag = this.sslVpnObject.sslVpnToggle ? this.sslVpnObject.nodeCount > 0 && (Number(this.sslVpnObject.nodeCount) + Number(this.sslVpnObject.totalNodeCount)) <= Number(this.sslVpnObject.maxNodeCount) &&
    (this.sslVpnObject.expiryType === 'selectExpiry' && this.sslVpnObject.dateSelected !== '' || this.sslVpnObject.expiryType === 'Never') : true;
    // console.warn('sslVpn', sslVpnFlag, this.sslVpnObject.serviceId !== '', this.sslVpnObject.nodeCount > 0, (Number(this.sslVpnObject.nodeCount) + Number(this.sslVpnObject.totalNodeCount)) <= Number(this.sslVpnObject.maxNodeCount));
    // console.warn('ss1', this.sslVpnObject.expiryType === 'selectExpiry' && this.sslVpnObject.dateSelected !== '' || this.sslVpnObject.expiryType === 'Never');
    return flag && sslVpnFlag;
  }
  async onNext() {
    this.showErrorMsg = true;
    if ((this.newProductModalObject.MSSPname !== '') && (this.newProductModalObject.tenantName !== '')) {
      this.showErrorMsgAnotherProductModal = true;
      this.newProductModalObject.performFurtherValidation = true;
      this.$store.commit('TenantManagementStoreModule/setNewProductObjectFurtherValidation', { performFurtherValidation: this.newProductModalObject.performFurtherValidation });
    }
    this.tzRequest.Mode = this.modalMode === 'add' ? 'PROVISION' : 'EDIT';
    this.tzRequest.productGroupId = this.modalMode !== 'add' ? this.newProductModalObject.tenantId : this.tenantId;
    const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    this.tzRequest.friendlyName = productModalDetails.productId === '27102' || productModalDetails.productId === '27104' || productModalDetails.productId === '28121' ||
    productModalDetails.productId === '27121' || productModalDetails.productId === '-11' ? this.tzRequest.friendlyName : productModalDetails.friendlyName;
    console.warn('tzRequest', (this.tzRequest.ProductID));
    if (productModalDetails.showOrganizationId) {
      this.tzRequest.subDomain = productModalDetails.subDomain;
      this.tzRequest.regionID = productModalDetails.regionSelected;
      this.tzRequest.regionName = productModalDetails.regionName;
    } else if (productModalDetails.productId === '-7' || productModalDetails.productId === '-8') {
      this.tzRequest.regionID = productModalDetails.regionSelected;
      this.tzRequest.regionName = productModalDetails.regionName;
      this.tzRequest.Services.splice(1);
    } else {
      this.tzRequest.Services[0].nodeCount = '1';
      this.tzRequest.Services[1].nodeCount = '1';
    }
    this.tzRequest.isHA = this.isHaProductId ? this.tzRequest.isHA : productModalDetails.showHA ? 'YES' : 'NO';
    if (this.isTzSelected && this.tzValidations) {
      try {
        if (this.sslVpnObject.sslVpnToggle) {
          const obj: any = {
            expirationDate: this.sslVpnObject.dateSelected !== '' ? this.sslVpnObject.dateSelected : 'Never',
            nodeCount: this.sslVpnObject.nodeCount,
            serviceId: this.sslVpnObject.serviceId,
          };
          this.tzRequest.Services[2] = obj;
        }
        if (this.tzRequest.validationMessage !== '') {
          confirmService.confirm({
            status: 'major',
            message: this.tzRequest.validationMessage,
            buttons: [{ key: 'cancel', name: String(this.$t('accessMgmt.cancel')) }, { key: 'ok', name: String(this.$t('common.confirm')), isDefault: true }],
          })
          .then((isConfirmed : any) => {
            if (isConfirmed === 'ok') {
              this.$store.commit('startLoading');
              return new Promise((res: any, rej: any) => {
                MswApiService.tenant.editProductProvision(this.tzRequest)
              .then((resp: any) => {
                if (resp.operationStatus === 'NOK') {
                  this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
                  rej(resp);
                } else {
                  this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
                  if (this.cseAutoRedirect === 'YES' && productModalDetails?.productId === '409' && this.modalMode === 'add') {
                    const request = {
                      tenant: this.tzRequest.productGroupId,
                      tileName: 'ISMSWSAFEENABLED',
                    };
                    this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
                    .then((resp: any) => {
                      if (resp?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
                        const cscAccessCode = resp?.content?.accessCode;
                        window.open(`${envCongif.spog_url}/muir/spog/login?code=${encodeURIComponent(cscAccessCode)}&mode=tileclick&stile=CSE&tenantid=${this.tzRequest.productGroupId}`, '_blank');
                      }
                    })
                    .catch((err: any) => {
                      this.$store.commit('stopLoading');
                      console.error(err);
                    })
                    .finally(() => {
                      this.$store.commit('stopLoading');
                    });
                  }
                  setTimeout(() => {
                    localStorage.setItem('tenants', '');
                    this.isTzSelected = false;
                    this.$emit('onclosePrductModal', true);
                    res(resp);
                  }, 500); // tslint:disable-line
                }
                setTimeout(() => {
                  this.$store.commit('stopLoading');
                }, 5000); // tslint:disable-line

              });
              });
            }
          });
        } else {
          this.$store.commit('startLoading');
          return new Promise((res: any, rej: any) => {
            MswApiService.tenant.editProductProvision(this.tzRequest)
          .then((resp: any) => {
            if (resp.operationStatus === 'NOK') {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
              rej(resp);
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
              if (this.cseAutoRedirect === 'YES' && productModalDetails?.productId === '409' && this.modalMode === 'add') {
                const request = {
                  tenant: this.tzRequest.productGroupId,
                  tileName: 'ISMSWSAFEENABLED',
                };
                this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
                .then((resp: any) => {
                  if (resp?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
                    const cscAccessCode = resp?.content?.accessCode;
                    window.open(`${envCongif.spog_url}/muir/spog/login?code=${encodeURIComponent(cscAccessCode)}&mode=tileclick&stile=CSE&tenantid=${this.tzRequest.productGroupId}`, '_blank');
                  }
                })
                .catch((err: any) => {
                  this.$store.commit('stopLoading');
                  console.error(err);
                })
                .finally(() => {
                  this.$store.commit('stopLoading');
                });
              }
              setTimeout(() => {
                localStorage.setItem('tenants', '');
                this.isTzSelected = false;
                this.$emit('onclosePrductModal', true);
                res(resp);
              }, 500); // tslint:disable-line
            }
            setTimeout(() => {
              this.$store.commit('stopLoading');
            }, 5000); // tslint:disable-line

          });
          });
        }
      } catch {
        this.$store.commit('stopLoading');
        // this.$emit('closeProductModal');
      }
    } else if (this.getValidationFlag && !this.isTzSelected) {
      localStorage.setItem('tenants', '');
      try {
        if (this.modalMode === 'add') {
          this.$store.commit('startLoading');
          await this.editProductProvisionApiCall();
        } else {
          this.$store.commit('startLoading');
          await this.editProductProvisionApiCall();
        }
        setTimeout(() => {
          this.$store.commit('stopLoading');
        }, 5000); // tslint:disable-line
        this.$emit('onSaveCloseProductModal');
      } catch {
        this.$store.commit('stopLoading');
        // this.$emit('closeProductModal');
      }
    }
  }

  formatDate(date: any) {
    const datearray = date.split('/');
    const newdate: any = datearray[1].concat('/', datearray[0], '/', datearray[2]);
    return newdate;
  }

  editProductProvisionApiCall() {
    return new Promise((res: any, rej: any) => {
      const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
      // const prodObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      // console.warn('prodObjr', prodObject, this.newProductModalObject.tenantId);
      const dataToBePosted: any = {
        ProductID: productModalDetails.productId,
        serviceId: productModalDetails.serviceName,
        nodeCount: productModalDetails.unitSelected === 'noUpperLimit' ? '99999' : productModalDetails.upperLimit,
        expirationDate: productModalDetails.expiryType === 'Never' ? 'Never' :  (productModalDetails.dateSelected),
        regionName: productModalDetails.regionName,

        regionID: productModalDetails.regionSelected,
        serialNumber: this.newProductModalObject.serialNumber,
        // platform: productModalDetails.platformName,
        productGroupId: this.modalMode !== 'add' ? this.newProductModalObject.tenantId : Number(this.tenantId),
        friendlyName: productModalDetails.friendlyName,
        isHA: productModalDetails.showHA ? 'YES' : 'NO',
        Mode: this.modalMode === 'add' ? 'PROVISION' : 'EDIT',
        // subdomain: productModalDetails.subDomain,
      };
      // if (productModalDetails.showFriendlyName === 'YES' || productModalDetails.showFriendlyName === 'READONLY') {
      //   dataToBePosted.friendlyName = productModalDetails.friendlyName;
      // }
      if (productModalDetails.showSubDomainName) {
        dataToBePosted.subdomain = productModalDetails.subDomain;
      }
      if (productModalDetails.showApplicationOption) {
        dataToBePosted.applicationId = productModalDetails.applicationName;
      }
      MswApiService.tenant.editProductProvision(dataToBePosted)
      .then((resp: any) => {
        const msspName = this.msspOptions.filter((ele:any) => ele.id.toString() === this.newProductModalObject.MSSPname)[0] || { label: this.newProductModalObject.MSSPname };
        this.$store.commit('TenantManagementStoreModule/setNewProductObjectMsspName', { MSSPname: this.msspOptions.length === 1 ? this.newProductModalObject.MSSPname : msspName.label });
        const tenntName = this.tenantOptions.filter((ele:any) => ele.id.toString() === this.newProductModalObject.tenantName)[0] || { label: this.newProductModalObject.tenantName };
        this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantName', { tenantName: tenntName.label });
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(resp);
        } else {
          this.newProductModalObject.accessScopeMessage = resp.AccessScope || '';
          this.newProductModalObject.isdefaultgroupAssignedtoTenant = resp.isdefaultgroupAssignedtoTenant || false;
          this.$store.commit('TenantManagementStoreModule/setNewProductAccessScope', { accessScopeMessage: this.newProductModalObject.accessScopeMessage });
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectdefaultGrpFlag', { isdefaultgroupAssignedtoTenant: this.newProductModalObject.isdefaultgroupAssignedtoTenant });
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          if (this.modalMode === 'add') {
            this.newProductModalObject.serialNumber = resp.Products[0].serialNumber;
            this.newProductModalObject.friendlyName = resp.Products[0].friendlyName;
            this.newProductModalObject.authCode = resp.Products[0].Authcode;
            this.$store.commit('TenantManagementStoreModule/setNewProductObjectSerialNumber', { serialNumber: this.newProductModalObject.serialNumber });
            this.$store.commit('TenantManagementStoreModule/setNewProductObjectFriendlyName', { friendlyName: this.newProductModalObject.friendlyName });
            this.$store.commit('TenantManagementStoreModule/setNewProductObjectAuthCode', { authCode: this.newProductModalObject.authCode });
            this.newProductModalObject.accessScopeMessage = resp.AccessScope || '';
            this.newProductModalObject.isdefaultgroupAssignedtoTenant = resp.isdefaultgroupAssignedtoTenant || false;
            this.$store.commit('TenantManagementStoreModule/setNewProductAccessScope', { accessScopeMessage: this.newProductModalObject.accessScopeMessage });
            this.$store.commit('TenantManagementStoreModule/setNewProductObjectdefaultGrpFlag', { isdefaultgroupAssignedtoTenant: this.newProductModalObject.isdefaultgroupAssignedtoTenant });
            // this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.$store.commit('TenantManagementStoreModule/setProductCreated', { productCreated: true });
          }
          res(resp);
        }
      });
    });
  }

  addProductProvisionApiCall() {
    return new Promise((res: any, rej: any) => {
      const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
      const dataToBePosted: any = {
        ProductID: productModalDetails.productId,
        serviceId: productModalDetails.serviceName,
        nodeCount: productModalDetails.unitSelected === 'noUpperLimit' ? '99999' : productModalDetails.upperLimit,
        expirationDate: productModalDetails.expiryType === 'Never' ? 'Never' :  (productModalDetails.dateSelected),
        regionName: productModalDetails.regionName,
        regionID: productModalDetails.regionSelected,
        productGroupId: Number(this.tenantId),
        friendlyName: productModalDetails.friendlyName,
        activateHA: productModalDetails.showHA ? 'YES' : 'NO',
        // subdomain: productModalDetails.subDomain,
      };
      // if (productModalDetails.showFriendlyName === 'YES' || productModalDetails.showFriendlyName === 'READONLY') {
      //   dataToBePosted.friendlyName = productModalDetails.friendlyName;
      // }
      if (productModalDetails.showSubDomainName) {
        dataToBePosted.subdomain = productModalDetails.subDomain;
      }
      if (productModalDetails.showApplicationOption) {
        dataToBePosted.applicationId = productModalDetails.applicationName;
      }
      MswApiService.tenant.addProductProvision(dataToBePosted)
      .then((resp: any) => {
        const msspName = this.msspOptions.filter((ele:any) => ele.id.toString() === this.newProductModalObject.MSSPname)[0] || { label: this.newProductModalObject.MSSPname };
        this.$store.commit('TenantManagementStoreModule/setNewProductObjectMsspName', { MSSPname: this.msspOptions.length === 1 ? this.newProductModalObject.MSSPname : msspName.label });
        const tenntName = this.tenantOptions.filter((ele:any) => ele.id.toString() === this.newProductModalObject.tenantName)[0] || { label: this.newProductModalObject.tenantName };
        this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantName', { tenantName: tenntName.label });
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(resp);
        } else {
          this.newProductModalObject.serialNumber = resp.Products[0].serialNumber;
          this.newProductModalObject.friendlyName = resp.Products[0].friendlyName;
          this.newProductModalObject.authCode = resp.Products[0].Authcode;
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectSerialNumber', { serialNumber: this.newProductModalObject.serialNumber });
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectFriendlyName', { friendlyName: this.newProductModalObject.friendlyName });
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectAuthCode', { authCode: this.newProductModalObject.authCode });
          this.newProductModalObject.accessScopeMessage = resp.AccessScope || '';
          this.newProductModalObject.isdefaultgroupAssignedtoTenant = resp.isdefaultgroupAssignedtoTenant || false;
          this.$store.commit('TenantManagementStoreModule/setNewProductAccessScope', { accessScopeMessage: this.newProductModalObject.accessScopeMessage });
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectdefaultGrpFlag', { isdefaultgroupAssignedtoTenant: this.newProductModalObject.isdefaultgroupAssignedtoTenant });
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          this.$store.commit('TenantManagementStoreModule/setProductCreated', { productCreated: true });
          res(resp);
        }
      });
    });
  }

  onProductSelectedFn() {
    this.enableProvision = false;
    this.enableAddAnotherProduct = true;
    this.changed = false;
  }
  onAccept(req: any, isDc:any, showExpiry:any, showChildExpiry:any, sslVpnObject: Object, unitSelected: string, childUnitSelected: string) {
    const agree = this.$store.getters['TenantManagementStoreModule/getTzProvision'];
    this.enableProvision = this.modalMode === 'edit' ? false : !agree;
    // console.warn('provisionEnabled', this.enableProvision, agree);
    req.tenantId = this.newProductModalObject.tenantName;
    this.tzRequest = req;
    this.isDcApplies = isDc;
    this.showExpiry =  showExpiry;
    this.showChildExpiry = showChildExpiry;
    this.sslVpnObject = sslVpnObject;
    this.unitSelected = unitSelected;
    this.childUnitSelected = childUnitSelected;
    const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    if (!this.isHaProductId) {
      this.tzRequest.friendlyName =  productModalDetails.friendlyName;
      this.tzRequest.isHA = productModalDetails.showHA ? 'YES' : 'NO';
    }
    this.isTzSelected = productModalDetails.productId === '-7' || productModalDetails.productId === '-8' || agree ? true : false;
  }
  sslToggleOff() {
    this.$emit('onOffSSLvpn');
  }
  onAddAnotherProduct() {
    const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const currentProductDetails = productDetailsFromStore.productDetails.slice();
    currentProductDetails.push({
      productName: 'Product',
      serviceName: '',
      unitSelected: 'noUpperLimit',
      expiryType: 'neverExpiry',
      regionSelected: '',
    });
    this.$store.commit('TenantManagementStoreModule/setNewProductObjectProductDetail', { productDetails: currentProductDetails });
    this.enableAddAnotherProduct = false;
  }

  get isHaProductId() {
    const haProductIds = ['27102', '27104', '28121', '27121', '-11', '-12', '-14', '-15', '-16', '-17', '-18', '-19', '-20'];
    const productModalDetails: AnotherProductObjectModalType = this.$store.getters['TenantManagementStoreModule/getAnotherProductModalObject'];
    return haProductIds.includes(productModalDetails?.productId);
  }

  get getMsspNewModaLObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewMsspModalObject'];
  }

  get getTenantNewModalObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewTenantModalObject'];
  }

  get productDetails() {
    return this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
  }
  get msspOptionList() {
    return this.$store.getters['TenantManagementStoreModule/getPreFilter'];
  }

  // get tempData() {
  //   const tempProductDetail = this.productDetails.productDetails.slice();
  //   const tempDataToBeSent = tempProductDetail.map((ele: ProductModalObjectType, index: any) => {
  //     return {
  //       id: index + 1,
  //       title: ele.productName,
  //       data: ele,
  //     };
  //   });
  //   return tempDataToBeSent;
  // }

  formatMsspOption() {
    const msspOption: SelectOption[] = [];
    const msspOps: any = [];
    if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.MSSPs) {
      this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: any) => {
        if (ele.MSSPName && ele.MSSPStatus !== 'INACTIVE') {
          msspOption.push({
            id: ele.MSSPID.toString(),
            label: ele.MSSPName,
            value: ele.MSSPID,
          });
        }
      });
    }
    this.msspOptions = [...msspOps, ...msspOption];
    if (this.newProductModalObject.MSSPname === '' && this.modalMode === 'add') {
      this.newProductModalObject.MSSPname = this.msspOptions.length === 1 ? this.msspOptions[0].label.toString() : this.newProductModalObject.MSSPname;
      // this.msspCheck = this.msspOptions.length === 2 ? true : this.msspFiltered;
      // this.msspFiltered = this.msspOptions.length === 2 ? true : this.msspFiltered;
      // console.warn('mssp', this.msspCheck);
    }
    if (this.newProductModalObject.MSSPname !== '' && this.newProductModalObject.MsspId === '') {
      this.newProductModalObject.MsspId = (this.msspOptions.filter(ele => this.newProductModalObject.MSSPname === ele.label || ele.id))[0].id;
    }
  }

  formatTenantOption() {
    const tenantOption: SelectOption[] = [];
    const tenantOps: any = [];
    const filterArray = this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.MSSPs || [];
    filterArray.map((ele: MsspPrefilterList) => {
      if (ele.MSSPID.toString() === this.newProductModalObject.MsspId) {
        if (ele.Tenants) {
          ele.Tenants.map((item: TenantPrefilterList) => {
            tenantOption.push({
              id: item.productGroupId.toString(),
              label: item.TenantName,
              value: item.productGroupId,
            });
          });
        }
      }
    });
    this.tenantOptions = [...tenantOps, ...tenantOption];
    if (this.newProductModalObject.tenantName === '' && this.modalMode === 'add') {
      // this.newProductModalObject.tenantName = this.tenantOptions.length === 2 ? this.tenantOptions[1].id : this.newProductModalObject.tenantName;
      // this.tenantCheck = this.tenantOptions.length === 2 ? true : this.tenantFiltered;
    }
    if (this.modalMode === 'add' && this.newProductModalObject.tenantName !== '') {
      this.onTenantSelected();
    }
  }

  formatMSSPTenants() {
    return new Promise((res) => {
      this.formatMsspOption();
      this.formatTenantOption();
      res(true);
    });
  }

  getMSSPTenantPrefilterList() {
    this.$store.commit('startLoading');
    return new Promise((res) => {
      MswApiService.tenant.getMsspPrefilter(false, false, true)
        .then((resp: MSSPPrefilterResponseType) => {
          this.msspPrefilterResponseFromApi = resp;
          res(true);
          this.$store.commit('stopLoading');
        })
        .catch(() => {
          this.$store.commit('stopLoading');
          res(true);
        });
    });
  }

  onMsspSelected() {
    // this.newProductModalObject.tenantName = '';
    this.changed = true;
    const msspId: any = (this.msspOptions.filter((ele: any) => ele.id === this.newProductModalObject.MSSPname));
    this.newProductModalObject.MsspId = msspId[0].id;
    this.formatTenantOption();
    this.$store.commit('TenantManagementStoreModule/setNewProductObjectMsspName', { MSSPname: this.newProductModalObject.MSSPname });
    this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: false });
    this.enableProvision = true;
  }

  onTenantSelected() {
    this.changed = true;
    if (this.newProductModalObject.MSSPname !== '' && this.newProductModalObject.tenantName !== '') {
      this.enableProductListApiCall = true;
    } else {
      this.enableProductListApiCall = false;
    }
    this.checkForWarning();
    const filterTenantId = this.tenantOptions.filter((ele: SelectOption) => ele.id === this.newProductModalObject?.tenantName || ele.label === this.newProductModalObject?.tenantName);
    this.tenantId = filterTenantId[0] ? filterTenantId[0]?.value ? filterTenantId[0]?.value.toString() : '' : '';
    this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantId', { tenantId: this.tenantId !== '' ? this.tenantId : this.newProductModalObject.tenantId });
    this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantName', { tenantName: this.tenantCheck ? filterTenantId[0]?.label : filterTenantId[0]?.id });
    this.$store.commit('TenantManagementStoreModule/setTenant', { tenants: !this.tenantCheck ? filterTenantId[0]?.label : this.newProductModalObject?.tenantName });
    localStorage.setItem('tenants', JSON.stringify(!this.tenantCheck ? filterTenantId[0]?.label : this.newProductModalObject?.tenantName));
    idb.refreshStore(TENANTS_STORE_NAME);
    this.$store.commit('TenantManagementStoreModule/setcapFName', { capFName: filterTenantId[0]?.label });
    this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: false });
    this.enableProvision = true;
  }

  async loadProductProvisionApi() {
    try {
      this.$store.commit('startLoading');
      this.$store.commit('TenantManagementStoreModule/setNewProductObjectFurtherValidation', { performFurtherValidation: false });
      if (this.modalMode === 'add') {
        await this.getMSSPTenantPrefilterList();
      } else {
        this.msspPrefilterResponseFromApi = this.msspPrefilterList;
      }
      await this.formatMSSPTenants();
      if (this.newProductModalObject.MSSPname === '' || this.newProductModalObject.tenantName === '') {
        const msspName = this.msspOptions.length === 1 ? this.msspOptions[0].id : this.msspCheck && this.modalMode === 'add'
        ? this.msspOptions.filter((ele:any) => this.getTenantNewModalObject.MSSPname === ele.id || this.getTenantNewModalObject.MSSPname === ele.label)[0].label : this.getTenantNewModalObject.MSSPname || '';
        const tenantName = this.getTenantNewModalObject.tenantName || 'tenant';
        const tenantIdVal = this.getTenantNewModalObject.tenantId ? this.getTenantNewModalObject.tenantId : 'tenant';
        const fetchMsspName = this.msspOptions.filter((ele: any) => ele.value.toString() === msspName || ele.label === msspName)[0];
        const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
        if (this.modalMode === 'add') {
          Object.assign(this.newProductModalObject, {
            MSSPname: this.msspOptions.length === 1 ? fetchMsspName.label : productDetailsFromStore.MSSPname !== '' && !this.msspCheck ? productDetailsFromStore.MSSPname :
            this.newProductModalObject.MSSPname !== '' ? this.newProductModalObject.MSSPname : fetchMsspName ? this.msspCheck ? fetchMsspName.label : fetchMsspName.id : '',
            MsspId: fetchMsspName ? fetchMsspName.id === '' ? productDetailsFromStore.MsspId : fetchMsspName.id : this.newProductModalObject.MsspId,
            tenantName: tenantName !== 'tenant' ? tenantName : productDetailsFromStore.tenantName ? productDetailsFromStore.tenantName :
            this.newProductModalObject.tenantName !== '' ? this.newProductModalObject.tenantName : tenantName,
            tenantId: productDetailsFromStore.tenantId ? productDetailsFromStore.tenantId : tenantIdVal,
          });
          await this.formatMSSPTenants();
          // this.newProductModalObject.tenantName = this.newProductModalObject.tenantName !== '' ? this.newProductModalObject.tenantName : tenantName;
          this.tenantId = productDetailsFromStore.tenantId ? productDetailsFromStore.tenantId : tenantIdVal;
          this.enableProductListApiCall = true;
          if (tenantIdVal !== '') {
            this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantId', { tenantId: tenantIdVal });
          }
        } else {
          Object.assign(this.newProductModalObject, {
            MSSPname: productDetailsFromStore.MSSPname,
            tenantName: productDetailsFromStore.tenantName,
            tenantId: productDetailsFromStore.tenantId,
            productDetails: productDetailsFromStore.productDetails,
            serialNumber: productDetailsFromStore.serialNumber,
          });
          this.checkForWarning();
        }
        if (this.tenantId !== '') {
          this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantId', { tenantId: this.tenantId });
        }
        this.$store.commit('TenantManagementStoreModule/setNewProductObjectMsspName', { MSSPname: this.newProductModalObject.MSSPname });
        this.$store.commit('TenantManagementStoreModule/setNewProductObjectTenantName', { tenantName: this.newProductModalObject.tenantName });
      } else {
        const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
        if (this.modalMode === 'add') {
          Object.assign(this.newProductModalObject, {
            MSSPname: productDetailsFromStore.MSSPname,
            tenantName: productDetailsFromStore.tenantName,
            tenantId: productDetailsFromStore.tenantId,
            productDetails: productDetailsFromStore.productDetails,
            serialNumber: productDetailsFromStore.serialNumber,
          });
        }
        this.checkForWarning();
      }
      if (this.modalMode === 'add') {
        this.$store.commit('stopLoading');
      }
    } catch {
      this.$store.commit('stopLoading');
    }
  }
  checkForWarning() {
    let selectedTenant: any = {};
    this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: any) => {
      if (ele.MSSPID.toString() === this.newProductModalObject.MsspId || ele.MSSPName.toString() === this.newProductModalObject.MSSPname) {
        selectedTenant = ele.Tenants.filter((val: any) => val.productGroupId.toString() === this.newProductModalObject.tenantName || val.TenantName.toString() === this.newProductModalObject.tenantName)[0];
        if (selectedTenant.showTenantAddressWarning === 'YES') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.addressWarning });
          this.tenantWarning = true;
        } else {
          this.tenantWarning = false;
        }
        if (selectedTenant?.affiliateTenantText) {
          this.affiliateTenantText = selectedTenant.affiliateTenantText === 'N/A' || null ? '' : selectedTenant.affiliateTenantText;
        }
      }
    });
    this.enableProvision = this.tenantWarning;
  }

  get checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MASTERMSSP')) {
      return true;
    }
    return false;
  }
  get checkForMsspNsm() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MSSPNSM')) {
      return true;
    }
    return false;
  }
  created() {
    this.enableProductListApiCall = false;
    this.msspCheck = this.msspFiltered;
    this.tenantCheck = this.tenantFiltered;
    // this.newProductModalObject.MSSPname = this.selectedMSSPID;
    // this.newProductModalObject.MsspId = this.selectedMSSPID;
    // this.newProductModalObject.tenantName = this.selectedTenantID;
    this.loadProductProvisionApi();
    this.editAlowed = this.showRename;
    this.$store.dispatch('getAppVersion')
    .then((result: any) => {
      this.cseAutoRedirect = result.content.cseAutoRedirect;
    });
  }
}
